import React from 'react';

import * as cs from 'app/components/Dashboard/MultiFeatureAnalysisWidget/MultiFeatureAnalysis.styl';
import {formatChartType} from 'app/components/Dashboard/utils/chartUtils';
import {formatDate} from 'app/utils/imageryUtils';
import {DataLayerInfo, ImageLayerInfo} from 'app/utils/layers';

import {MultifeatureAnalysisConfig} from '../types';

export const ChartDescription = ({
  widgetConfig,
  layer,
  isExpanded,
  setIsExpanded,
}: {
  widgetConfig: MultifeatureAnalysisConfig;
  layer: DataLayerInfo | ImageLayerInfo;
  isExpanded: boolean;
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <div>
      <p>
        <span className={cs.widgetLabel}>Description:</span> {widgetConfig.description}
      </p>
      <p>
        <span className={cs.widgetLabel}>Chart: </span>
        {formatChartType(widgetConfig)} of {layer.display}
        {' | '}
        {widgetConfig.featureIds?.length || 'all'} properties
        {' | '}
        {formatDate(widgetConfig.startDate, layer.key)}
        {' - '}
        {formatDate(widgetConfig.endDate, layer.key)}
        {' | '}
        <a onClick={() => setIsExpanded((expanded) => !expanded)}>
          {isExpanded ? 'See less' : 'See more'}
        </a>
      </p>
    </div>
  );
};
